import {ComponentProps, FC} from 'react';

import {twx} from '@/utils/tailwindUtils';

import {useFieldContext} from '../context';

interface LabelProps extends ComponentProps<'label'> {}

export const FieldLabel: FC<LabelProps> = ({children, className, ...rest}) => {
    const {id} = useFieldContext();

    return (
        <label htmlFor={id} className={twx('block text-14 leading-[20px] tracking-04', className)} {...rest}>
            {children}
        </label>
    );
};
